import Big from 'big.js';

const DECIMAL = /^[+-]?[0-9]+(\.[0-9]+)?$/;

/** Fração decimal → percentual decimal: `'0.0185'` → `'1.85'`. */
export function fractionToPercent(fraction: string): string {
  if (!DECIMAL.test(fraction.trim())) throw new Error(`fração inválida: ${fraction}`);
  return new Big(fraction.trim()).times(100).toFixed();
}

/** Percentual decimal → fração decimal: `'1.85'` → `'0.0185'`. É o que o legado grava. */
export function percentToFraction(percent: string): string {
  if (!DECIMAL.test(percent.trim())) throw new Error(`percentual inválido: ${percent}`);
  return new Big(percent.trim()).div(100).toFixed();
}

export interface FormatPercentOptions {
  readonly locale?: string;
  /** Casas do percentual exibido. Padrão: 2 mínimas, 4 máximas. */
  readonly minimumFractionDigits?: number;
  readonly maximumFractionDigits?: number;
}

/** Formata uma fração para exibição: `'0.0185'` → `1,85%`. */
export function formatPercent(fraction: string, options: FormatPercentOptions = {}): string {
  if (!DECIMAL.test(fraction.trim())) throw new Error(`fração inválida: ${fraction}`);
  const formatter = new Intl.NumberFormat(options.locale ?? 'pt-BR', {
    style: 'percent',
    minimumFractionDigits: options.minimumFractionDigits ?? 2,
    maximumFractionDigits: options.maximumFractionDigits ?? 4,
  });
  return formatter.format(fraction.trim() as `${number}`);
}
